exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt3[data-v-38372454] {\n  color: #033C89;\n  font-size: 24px;\n  line-height: 29px;\n}\n.sub-title[data-v-38372454] {\n  color: #414141;\n  margin-top: 10px;\n  margin-bottom: 25px;\n  font-size: 20px;\n}\n.text-content[data-v-38372454] {\n  color: #52678D;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.12px;\n}\n", ""]);

// exports
